import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as types from './store/mutation-types'

import '@/assets/sass/sass_index.scss'
import {validate, util, widget} from '@/utils/index'
import {apis} from '@/request/api'
import {post, get} from '@/request/index'
import md5 from 'js-md5'
import { Button ,Cell,Icon,Field,Popup,Loading,NumberKeyboard,Toast,List} from 'vant';
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
router.beforeEach((to, from, next) => {
    if(to.meta.title){
        document.title = to.meta.title
    }
    next()
})

Vue.use(Button)
Vue.use(Cell)
Vue.use(Icon)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Loading)
Vue.use(NumberKeyboard)
Vue.use(Toast)
Vue.use(List)
Vue.config.productionTip = false
Vue.prototype.$apis = apis
Vue.prototype.$types = types
Vue.prototype.$validate = validate
Vue.prototype.$util = util
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$widget = widget
Vue.prototype.$md5 = md5

// var deviceWidth
// setHtmlFontSize()
// if (window.addEventListener) {
//     window.addEventListener('resize', setHtmlFontSize, false)
// }
// function setHtmlFontSize () {
//     // 1920是设计稿的宽度，当大于1920时采用1920宽度，比例也是除以19.20
//     deviceWidth = document.documentElement.clientWidth > 750 ? 750 : document.documentElement.clientWidth
//     document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 113 + 'px !important'
// }
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
